<template>
    <div class="wb-sidebar-categories"
         ref="categoriesContainer"
         v-on:scroll="scrollComputeHandler()">
        <SidebarCategoriesScroll :direction="'up'"
                                 :width="'152px'"
                                 v-show="showTopScroll"
                                 v-on:click="scrollByClick(-1)"/>
        <div class="wb-sidebar-categories-list">
            <SidebarCategoriesLabel :text="'ПОСТРОЕНИЕ'"/>
            <div class="wb-sidebar-categories-group">
                <div v-for="item of constructionCategories" :key="item.id">
                    <div class="wb-c-green-line-h"></div>
                    <SidebarCategoriesItem :data="item"
                                           :is-selected="isSelected(categoriesSections.construction, item.id)"
                                           :type="categoriesSections.construction"
                                           v-on:mouseenter="storeData.setActiveCategory(categoriesSections.construction, item.id)"
                                           v-on:click.stop="storeData.setActiveCategory(categoriesSections.construction, item.id)"/>
                </div>
            </div>
            <div class="wb-sidebar-categories-gap"></div>

            <SidebarCategoriesLabel :text="'КАТАЛОГ'"/>
            <div class="wb-sidebar-categories-group">
              <div v-for="item of categories" :key="item.id">
                <div class="wb-c-green-line-h"></div>
                <SidebarCategoriesItem :data="item"
                                       :is-selected="isSelected(categoriesSections.catalog, item.id)"
                                       :type="categoriesSections.catalog"
                                       v-on:mouseenter="storeData.setActiveCategory(categoriesSections.catalog, item.id)"
                                       v-on:click.stop="storeData.setActiveCategory(categoriesSections.catalog, item.id)"/>
              </div>
            </div>
        </div>
        <SidebarCategoriesScroll :direction="'down'"
                                 :width="'152px'"
                                 v-show="showBotScroll"
                                 v-on:click="scrollByClick(1)"/>
    </div>
</template>

<script>
import SidebarCategoriesLabel from '@/UI/Components/ComponentsSidebarCategories/SidebarCategoriesLabel.vue';
import SidebarCategoriesItem from '@/UI/Components/ComponentsSidebarCategories/SidebarCategoriesItem.vue';
import SidebarCategoriesScroll from '@/UI/Components/ComponentsSidebarCategories/SidebarCategoriesScroll.vue';
import { useStoreData } from '@/Store/storeData';
import { categoriesSections } from '@/Constants/common';

export default {
    name: 'TheSidebarCategories',
    components: {
        SidebarCategoriesScroll,
        SidebarCategoriesItem,
        SidebarCategoriesLabel,
    },
    setup() {
        const storeData = useStoreData();
        return {
            storeData,
        };
    },
    props: [
        'openSidebarMenu',
        'constructionCategories',
        'categories',
    ],
    data() {
        return {
            scrollHeight: 0,
            scrollTop: 0,
            containerHeight: 0,
            scrollStep: 131,
        };
    },
    computed: {
        categoriesSections() {
            return categoriesSections;
        },
        showTopScroll() {
            return this.scrollTop > 0;
        },
        showBotScroll() {
            return this.scrollHeight > this.containerHeight + this.scrollTop;
        },
    },
    methods: {
        isSelected(categoryId, itemId) {
            return (
                this.storeData.getActiveCategoriesSection === categoryId &&
                this.storeData.getActiveCategory === itemId
            );
        },
        scrollComputeHandler() {
            this.scrollHeight = this.getScrollHeight();
            this.scrollTop = this.getScrollTop();
            this.containerHeight = this.getContainerHeight();
        },
        getScrollHeight() {
            return this.$refs.categoriesContainer?.scrollHeight;
        },
        getScrollTop() {
            return this.$refs.categoriesContainer?.scrollTop;
        },
        getContainerHeight() {
            return this.$refs.categoriesContainer?.clientHeight;
        },
        scrollByClick(direction) {
            // TODO add smooth animation
            this.$refs.categoriesContainer.scrollTop = this.$refs.categoriesContainer.scrollTop + direction * this.scrollStep;
        },
    },
    mounted() {
        this.scrollComputeHandler();
        window.addEventListener('resize', this.scrollComputeHandler);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.scrollComputeHandler);
    },
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
@import "CSS/common.scss";

.wb-sidebar-categories {
    width: 152px;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: $darkBlue;

    -ms-overflow-style: none;
    scrollbar-width: none;
}

.wb-sidebar-categories::-webkit-scrollbar {
    display: none;
}

.wb-sidebar-categories-list {
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
}

.wb-sidebar-categories-gap {
    height: 40px;
    width: 100%;
}

.wb-sidebar-categories-group {
    display: flex;
    flex-direction: column;
    height: max-content;
    width: 100%;
    box-sizing: border-box;
}

</style>
